import React, { Component } from "react";
import {
    AutoComplete,
    Button,
    Card,
    Checkbox,
    Col,
    DatePicker,
    Form,
    Icon,
    Input,
    InputNumber,
    Modal,
    Row,
    Select,
    Spin,
} from "antd";
import moment from "moment/moment";
import {
    fetchAssetFuels,
    fetchBowserAssets,
    fetchFilter,
    fetchMasterFilter,
    fetchMasterFilterData,
    fetchPageSettingFilter,
    fetchRelationshipSearchData,
    searchGlobalAssetData,
} from "../../appRedux/actions";

import {
    fetchResourceByPage,
    updateResource as pageSettingUpdate,
} from "../../appRedux/actions/PageSetting";
import { fetchResource as fetchAssetModel } from "../../appRedux/actions/AssetModel";
import { connect } from "react-redux";
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import Mileage from "./Mileage";
import { message } from "antd/lib/index";
import { isEmpty, isEqual } from "lodash";
import { createDebounce, sanitizeFieldName } from "../../util/methods";
import ImageList from "./Photos";
import ImagePreviewModal from "../../components/ImagePreviewModal";
import PageSettingPopUp from "../PageSetting/settingForm";
import AccessControl from "../../components/AccessControl";
import AssetSearch from "../../components/AssetSearch";
import axios from 'util/Api'
class Refuel extends Component {
    constructor() {
        super();
        this.id = 0;
        this.state = {
            selectedFuelDate: "",
            selectedAsset: "",
            selectedDateTime: null,
            selectedAssetData: null,
            selectedAssetObject: null,
            selectedFuelType: "",
            fuelTypes: [],
            mileageData: [],
            visible: false,
            isBowser: false,
            qtySelected: 0,
            rateSelected: 0,
            receiptSelected: "",
            bowserAssetSelected: "",
            documentImage: [],
            photoPreview: { visible: false, index: 0 },
            pageSettingVisible: false,
            currentAssetMeters: [],
            bowserBalanceQuantity: null,
            bowserBalanceCheck: false,
            removedPhotoUrls: [],
        };
    }

    isSameAssetSelection = (assetId, bowserId) => {
        if (!assetId || !bowserId) return false;
        return assetId.toString() === bowserId.toString();
    }

    resetBowserSelection = () => {
        this.setState({
            bowserAssetSelected: "",
            bowserBalanceQuantity: null,
            bowserBalanceCheck: false
        });
        this.props.form.setFieldsValue({
            bowserAsset: undefined
        });
    }

    getAvailableBowsers = () => {
        const { bowsers } = this.props;
        const { selectedAsset } = this.state;
        return (bowsers || []).filter((item) => {
            if (!item || !item._id) return false;
            return !this.isSameAssetSelection(selectedAsset, item._id);
        });
    }

    setCurrentAssetMeters = (meters) => {
        this.setState({
            currentAssetMeters: meters
        })
    }

    togglePageSettingVisible = () => {
        this.setState({
            pageSettingVisible: !this.state.pageSettingVisible,
        });
    };

    componentDidMount = () => {
        this.props.fetchMasterFilterData();
        const { match, fetch, data, pageSettingData } = this.props;
        if (match.params && match.params.id) {
            fetch(match.params.id);
        }
        const { date } = data || {};
        if (!date) {
            this.handleChange("fuelDate", moment());
        }
        if (this.props.fetchResourceByPage && this.props.resource) {
            // pageSettingData
            // console.log('setting fetch', this.props.resource)
            this.props.fetchResourceByPage(this.props.resource);
        }
        // Handle case where pageSettingData is already available on mount
        if (pageSettingData && pageSettingData.settings && !data) {
            const pageSettings = pageSettingData.settings || [];
            const defaultIsBowser = this.getDefaultValue(pageSettings, "isBowser") === 'true'
            if (defaultIsBowser) {
                this.setState({
                    isBowser: true
                })
                this.props.form.setFieldsValue({
                    isBowser: true
                })
            }
        }
    };

    componentWillReceiveProps(nextProps) {
        if (!isEqual(nextProps, this.props)) {
            // Only re-initialise the form from `data` when `data` itself changed.
            // Without this guard, any unrelated prop update (e.g. the bowser list
            // arriving from a bowserAsset search) re-syncs the whole form and wipes
            // the user's in-progress selections — unchecking "Is Filled from Bowser?"
            // and clearing the selected bowser mid-typing.
            if (nextProps.data && !isEmpty(nextProps.data) && !isEqual(nextProps.data, this.props.data)) {
                const {
                    _id,
                    date,
                    asset,
                    typeOfFuel,
                    mileage,
                    isBowser,
                    quantity,
                    rate,
                    receiptNumber,
                    bowserAsset,
                    isFilledToFull,
                    isFullTank,
                    operator,
                    voucherNo,
                } = nextProps.data;

                const isNewRecord = !this.props.data || nextProps.data._id !== this.props.data._id;
                const mileageDataFromProps = (isNewRecord ? mileage : this.state.mileageData);

                this.setState({
                    _id,
                    selectedFuelDate: date,
                    selectedAsset: asset._id,
                    selectedAssetObject: asset,
                    selectedFuelType: typeOfFuel._id,
                    mileageData: mileageDataFromProps != null ? mileageDataFromProps : mileage,
                    isBowser,
                    qtySelected: quantity,
                    rateSelected: rate,
                    receiptSelected: receiptNumber,
                    bowserAssetSelected: bowserAsset ? bowserAsset._id : null,
                    removedPhotoUrls: [],
                });

                // Update form fields for edit mode
                this.props.form.setFieldsValue({
                    isBowser: isBowser,
                    qty: quantity,
                    rate: rate,
                    receiptNo: receiptNumber,
                    isFilledToFull: isFilledToFull !== undefined ? isFilledToFull : !!isFullTank,
                    operator: operator && operator._id,
                    voucherNo: voucherNo
                });

                // Check bowser balance if editing existing record with bowser asset
                if (bowserAsset && bowserAsset._id && isBowser) {
                    this.setState({
                        bowserBalanceCheck: true,
                        bowserBalanceQuantity: null
                    });

                    axios.get(`/bowser-fuel-transactions/bowser-balance/${bowserAsset._id}/${moment(date).valueOf()}`)
                        .then(res => {
                            // console.log('Edit mode bowser balance res =>', res);
                            // In edit mode, add the current record's quantity to show balance excluding this entry
                            const currentBalance = res.data || 0;
                            const adjustedBalance = currentBalance + quantity;
                            this.setState({
                                bowserBalanceQuantity: adjustedBalance
                            });
                        })
                        .catch(err => {
                            console.log('Edit mode bowser balance err =>', err);
                            this.setState({
                                bowserBalanceQuantity: null
                            });
                        })
                        .finally(() => {
                            this.setState({
                                bowserBalanceCheck: false
                            });
                        });
                }
            }

            if (nextProps.data && JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)) {
                const photos = (nextProps.data && nextProps.data.photos) || [];
                const photoData = photos
                    .filter((p) => p && p.url)
                    .map((p) => ({
                        uid: p.url,
                        name: p.name || 'photo',
                        status: 'done',
                        url: p.url,
                        type: p.mimeType,
                    }));

                this.props.form.setFieldsValue({ photos: photoData });
                this.setState({ documentImage: photoData });
            }

            if (nextProps.data &&
                nextProps.data.asset &&
                JSON.stringify(nextProps.data.asset) !== JSON.stringify(this.props.data.asset)) {
                // console.log(nextProps.data.asset, this.props.data.asset)
                // this.handleChange("asset", nextProps.data.asset._id)
                if (nextProps.data.asset.assetModel)
                    this.props.fetchAssetModel(nextProps.data.asset.assetModel);

                if (nextProps.data.asset && nextProps.data.date) {
                    this.props.fetchAssetFuels(nextProps.data.asset._id, nextProps.data.date, nextProps.data._id);
                }
            }

            if (
                nextProps &&
                nextProps.assetModel &&
                JSON.stringify(nextProps.assetModel) !==
                JSON.stringify(this.props.assetModel)
            ) {
                const assetModel = nextProps.assetModel;
                // console.log(assetModel)
                let fuelType = (assetModel && assetModel.fuelType) || "";
                // let fuelType = assetFiltered && assetFiltered.length > 0 && assetFiltered[0].assetModel && assetFiltered[0].assetModel.hasOwnProperty('fuelType') ? assetFiltered[0].assetModel.fuelType : '';
                // if (fuelType)
                // fuelType = ((this.props.filters['typeOfFuel'] && this.props.filters['typeOfFuel'].data.data) || []).filter(item => item._id.toString()
                //   === fuelType.toString());

                // let assetModel = assetFiltered && assetFiltered.length > 0 && assetFiltered[0].assetModel;
                if (!assetModel || !assetModel.meters || !assetModel.meters.length) {
                    message.error(
                        `Please set Meters in the selected asset model - (${assetModel && assetModel.name})`,
                        10,
                    );
                }
                if (!fuelType) {
                    message.error(
                        `Please set FuelType in the selected asset model - (${assetModel && assetModel.name})`,
                        10,
                    );
                }
                this.setState({
                    visible: !!(fuelType && fuelType._id),
                });
                this.handleChange("fuelType", (fuelType && fuelType._id) || null);
            }

            if (nextProps.pageSettingData && !isEqual(nextProps.pageSettingData, this.props.pageSettingData)) {
                const pageSettings = (nextProps.pageSettingData && nextProps.pageSettingData.settings) || [];
                const defaultIsBowser = this.getDefaultValue(pageSettings, "isBowser") === 'true'
                this.setState({
                    isBowser: defaultIsBowser
                })
                // Update form field value if default is true and we're not in edit mode
                if (defaultIsBowser && !nextProps.data) {
                    this.props.form.setFieldsValue({
                        isBowser: true
                    })
                }
            }

            if (nextProps.data && !isEqual(nextProps.data, this.props.data)) {
                const { isBowser } = nextProps.data;
                if (isBowser) {
                    this.setState({
                        isBowser: isBowser
                    })
                }
            }
        }
    }

    showModal = () => {
        this.setState({ visible: true });
    };

    handleCancel = () => {
        this.setState({ visible: false });
    };

    handelMileageCreate = (values) => {
        const { meterUnits } = this.props.filterData;
        const unitList =
            meterUnits && meterUnits.data && meterUnits.data.count > 0
                ? meterUnits.data.data
                : [];
        // const unitObj = unitList.filter(item => item._id.toString() === values.unit.toString());
        const { mileageData } = this.state;
        // console.log(values, mileageData)
        const index = mileageData.findIndex(
            (item) => item.name === values.name,
        );
        if (index !== -1) {
            // Object with the same name and unit exists, so overwrite it
            mileageData[index] = values;
        } else {
            // Object doesn't exist, so add it to the array
            mileageData.push(values);
        }
        // mileageData.push(values);
        this.setState({
            mileageData,
            // visible: false,
        });
    };

    debouncedSearch = createDebounce((searchValue) => {
        this.props.fetchRelationshipSearchData(searchValue, "Asset", "assetCode");
    }, 400);

    assetSearch = createDebounce((value) => {
        // if (value && value.length >= 2)
        //   this.debouncedSearch(value);
        this.props.searchGlobalAssetData(value);
    });

    bowserSearch = (_) => {
        if (this.state.selectedAsset && this.state.selectedFuelType && this.state.selectedFuelDate) {
            let assetTaken = [];
            if (this.props.assetData && this.props.assetData.length > 0)
                assetTaken = this.props.assetData.filter(
                    (asset) =>
                        asset._id.toString() === this.state.selectedAsset.toString(),
                );
            else if (this.state.selectedAssetObject) {
                assetTaken.push(this.state.selectedAssetObject);
            } else message.error(`Select asset and fuel type first!`);
            if (assetTaken.length > 0 && assetTaken[0].location) {
                this.props.fetchBowserAssets(
                    assetTaken[0].location,
                    this.state.selectedFuelType,
                );
            } else message.error(`Select asset and fuel type first!`);
        } else message.error(`Select asset, fuel type and date first!`);
    };

    setMileageData = (data) => {
        //console.log(data);
    };

    removeMileage = (index) => {
        const { mileageData } = this.state;
        if (mileageData.length === 1) {
            return;
        }

        mileageData.splice(index, 1);
        this.setState({
            mileageData,
        });
    };

    handleChange = (type, value) => {
        switch (type) {
            case "meterReading":
                if (value != null) {
                    // console.log('value =>', value)
                    this.setState(() => ({
                        mileageData: Array.isArray(value) ? value : [value]
                    }), () => {
                        // console.log('mileageData =>', this.state.mileageData)
                        // console.log('new mileageData =>', this.state.mileageData)
                    })
                }
                break;
            case "fuelDate":
                // console.log(value)
                this.setState({
                    selectedFuelDate: value, //moment(value).format("YYYY-MM-DD HH:mm:ss"),
                });
                if (this.state.selectedAsset) {
                    // todo: check if date is same as today, if yes then fetch only current day data
                    this.props.fetchAssetFuels(this.state.selectedAsset, value);
                }

                // Refresh bowser balance if bowser asset is already selected
                if (this.state.bowserAssetSelected && this.state.isBowser) {
                    this.setState({
                        bowserBalanceCheck: true,
                        bowserBalanceQuantity: null
                    });

                    axios.get(`/bowser-fuel-transactions/bowser-balance/${this.state.bowserAssetSelected}/${moment(value).valueOf()}`)
                        .then(res => {
                            console.log('Date change bowser balance res =>', res);
                            // In edit mode, add the current record's quantity to show balance excluding this entry
                            const currentBalance = res.data || 0;
                            const adjustedBalance = this.state._id ? currentBalance + this.state.qtySelected : currentBalance;
                            this.setState({
                                bowserBalanceQuantity: adjustedBalance
                            });
                        })
                        .catch(err => {
                            console.log('Date change bowser balance err =>', err);
                            this.setState({
                                bowserBalanceQuantity: null
                            });
                        })
                        .finally(() => {
                            this.setState({
                                bowserBalanceCheck: false
                            });
                        });
                }
                break;
            case "fuelType":
                this.setState({
                    selectedFuelType: value,
                });
                this.props.form.setFieldsValue({ fuelType: value });

                // Clear bowser asset and balance when fuel type changes
                // as different fuel types may have different bowser assets
                if (this.state.bowserAssetSelected) {
                    this.setState({
                        bowserAssetSelected: "",
                        bowserBalanceQuantity: null,
                        bowserBalanceCheck: false
                    });
                }
                break;
            case "rate":
                // console.log(value);
                this.setState({
                    rateSelected: value,
                });
                break;
            case "qty":
                // console.log(value);
                this.setState({
                    qtySelected: value,
                });
                break;
            case "bowserAsset":
                if (this.isSameAssetSelection(this.state.selectedAsset, value)) {
                    message.error("Issue to asset and issue from bowser cannot be the same asset.");
                    this.resetBowserSelection();
                    return;
                }
                // console.log('bowserAssetSelected =>', value)
                // call api to fetch the balance quantity
                this.setState({
                    bowserBalanceCheck: true,
                    bowserAssetSelected: value,
                    bowserBalanceQuantity: null
                })
                axios.get(`/bowser-fuel-transactions/bowser-balance/${value}/${moment(this.state.selectedFuelDate).valueOf()}`)
                    .then(res => {
                        // console.log('res =>', res)
                        this.setState({
                            bowserBalanceQuantity: res.data || null
                        })
                    })
                    .catch(err => {
                        console.log('err =>', err)
                        this.setState({
                            bowserBalanceQuantity: null
                        })
                    }).finally(() => {
                        this.setState({
                            bowserBalanceCheck: false
                        })
                    })
                break;
            case "receiptNo":
                this.setState({
                    receiptSelected: value.target.value,
                });
                break;
            case "isBowser":
                this.setState({
                    isBowser: value.target.checked,
                });
                break;
            case "asset":
                // console.log('Asset Selected : ', value)
                if (!this.state.selectedFuelDate) {
                    message.error(`Please select Date first!`);
                    this.props.form.setFieldsValue({
                        asset: "",
                    });
                } else {
                    this.props.fetchAssetFuels(value, this.state.selectedFuelDate, this.props.data && this.props.data._id || '');

                    const assetFiltered = this.props.assetData && this.props.assetData.length && this.props.assetData.filter(
                        (asset) => asset._id.toString() === value.toString(),
                    );

                    if (
                        assetFiltered &&
                        assetFiltered.length > 0 &&
                        assetFiltered[0].assetModel
                    )
                        this.props.fetchAssetModel(assetFiltered[0].assetModel);

                    this.setState({
                        selectedAsset: value,
                        selectedAssetData:
                            assetFiltered && assetFiltered.length && assetFiltered[0],
                        // visible: !!(fuelType && fuelType.length)
                        //selectedFuelType: fuelType && fuelType.length > 0 ? fuelType[0].name : '',
                    });

                    if (this.isSameAssetSelection(value, this.state.bowserAssetSelected)) {
                        this.resetBowserSelection();
                        message.warning("Bowser selection was cleared because it cannot be the same as the selected asset.");
                    }
                    // this.handleChange('fuelType', fuelType && fuelType.length > 0 ? fuelType[0]._id : '');
                }
                break;
            default:
        }
    };

    handleSubmit = (e) => {
        const { match, assetFuels, assetData } = this.props;
        e.preventDefault();
        e.stopPropagation();
        this.props.form.validateFields((err, values) => {
            if (err) {
            } else {
                const {
                    _id,
                    selectedFuelDate,
                    selectedAsset,
                    selectedAssetObject,
                    selectedAssetData,
                    selectedFuelType,
                    isBowser,
                    qtySelected,
                    rateSelected,
                    receiptSelected,
                    bowserAssetSelected,
                    documentImage,
                    currentAssetMeters
                } = this.state;
                // console.log('currentAssetMeters =>', currentAssetMeters)
                // console.log('mileageData =======', mileageData);
                // console.log('Selected asset =>', selectedAsset)
                // console.log('assetFuels =>', assetFuels)
                // console.log('assetData =>', assetData)
                // Get the expected number of meters from assetModel
                // const expectedMeterCount = this.props.assetModel && this.props.assetModel.meters ? this.props.assetModel.meters.length : 0;

                const meterReadingsFromForm = values && values.meterReading ? values.meterReading : {};
                const faultyMetersFromForm = values && values.isFaultyMeter ? values.isFaultyMeter : {};
                const meterMap = (currentAssetMeters || []).reduce((acc, meter) => {
                    if (meter && meter._id) {
                        acc[meter._id.toString()] = meter;
                    }
                    return acc;
                }, {});
                const toMileageMapByMeter = (mileageList = []) => mileageList.reduce((acc, mileageItem) => {
                    if (!mileageItem) return acc;
                    const meterId = mileageItem && mileageItem.meter && mileageItem.meter._id
                        ? mileageItem.meter._id.toString()
                        : mileageItem && mileageItem.meter
                            ? mileageItem.meter.toString()
                            : null;
                    if (meterId) {
                        acc[meterId] = mileageItem;
                    }
                    return acc;
                }, {});
                const existingMileageFromState = toMileageMapByMeter(this.state.mileageData || []);
                const existingMileageFromProps = toMileageMapByMeter((this.props.data && this.props.data.mileage) || []);
                const getMeterReadingRecordId = (mileageItem) => {
                    if (!mileageItem) return undefined;
                    if (mileageItem.meterReadingRecord && mileageItem.meterReadingRecord._id) {
                        return mileageItem.meterReadingRecord._id;
                    }
                    if (mileageItem.meterReadingRecord) {
                        return mileageItem.meterReadingRecord;
                    }
                    return undefined;
                };
                const expectedMeters = currentAssetMeters.filter(meter => meter.asset && meter.asset._id && meter.asset._id.toString() === selectedAsset.toString())
                const expectedMeterIds = expectedMeters.map(meter => meter && meter._id && meter._id.toString()).filter(Boolean);
                // Only build mileage from meters that actually belong to the selected asset.
                // The previous code fell back to the raw meterReading/isFaultyMeter form keys
                // when this list was empty. Right after switching assets there is an async gap
                // where currentAssetMeters still holds the PREVIOUS asset's meters while the
                // new asset's list is being fetched; in that window the fallback emitted the
                // old asset's meter together with the new asset, producing a fuel record and
                // an AssetMeterReading on two different assets under the same voucher. If the
                // meter list has not loaded for this asset yet, block the submit rather than
                // guessing from stale form keys.
                if (expectedMeterIds.length <= 0) {
                    message.error('Meters are still loading for the selected asset. Please wait a moment and try again.');
                    return;
                }
                const meterIdsToProcess = expectedMeterIds;

                const invalidMeterReadings = meterIdsToProcess
                    .filter((meterId) => {
                        if (faultyMetersFromForm[meterId]) {
                            return false;
                        }
                        const rawReading = meterReadingsFromForm[meterId];
                        if (rawReading === '' || rawReading === null || rawReading === undefined) {
                            return false;
                        }
                        const numericReading = Number(rawReading);
                        return Number.isNaN(numericReading) || numericReading <= 0;
                    });

                if (invalidMeterReadings.length > 0) {
                    const invalidMeterNames = invalidMeterReadings
                        .map((meterId) => (meterMap[meterId] && meterMap[meterId].meterNo) || meterId)
                        .join(', ');
                    message.error(`Meter reading must be greater than 0 for meter(s): ${invalidMeterNames}`);
                    return;
                }

                const mileageData = meterIdsToProcess
                    .map((meterId) => {
                        const meterDoc = meterMap[meterId] || {};
                        const existingMeterReadingRecordId =
                            getMeterReadingRecordId(existingMileageFromState[meterId]) ||
                            getMeterReadingRecordId(existingMileageFromProps[meterId]);
                        const isFaultyMeter = !!faultyMetersFromForm[meterId];
                        const rawReading = meterReadingsFromForm[meterId];
                        const readingValue = isFaultyMeter
                            ? null
                            : (rawReading === '' || rawReading === null || rawReading === undefined ? null : Number(rawReading));
                        return {
                            meter: meterId,
                            reading: readingValue,
                            unit: meterDoc && meterDoc.meterType && meterDoc.meterType._id,
                            name: meterDoc && meterDoc.meterType && meterDoc.meterType.name,
                            meterReadingRecord: existingMeterReadingRecordId,
                            isFaultyMeter
                        };
                    })
                    .filter((item) => item.isFaultyMeter || item.reading !== null)
                    .filter((item) => item.isFaultyMeter || !Number.isNaN(item.reading));

                // console.log('expectedMeters =>', expectedMeters)
                // console.log('mileageData =>', mileageData)
                if (!mileageData || mileageData.length <= 0) {
                    message.error("Meter readings are required!");
                    return;
                } else if (expectedMeters.length > 0) {
                    // Check if all required meters have readings
                    // console.log('mileageData****:', mileageData)
                    // const requiredMeterIds = this.props.assetModel.meters.map(meter => meter._id);
                    const requiredMeterIds = expectedMeters.map(meter => meter && meter._id && meter._id.toString()).filter(Boolean);
                    const requiredNonFaultyMeterIds = requiredMeterIds.filter((meterId) => !faultyMetersFromForm[meterId]);
                    const providedMeterIds = mileageData
                        .filter((reading) => !reading.isFaultyMeter)
                        .map(reading => reading && reading.meter && reading.meter.toString())
                        .filter(Boolean);
                    // console.log('requiredMeterIds =>', requiredMeterIds)
                    // console.log('providedMeterIds =>', providedMeterIds)
                    const missingMeters = requiredNonFaultyMeterIds.filter(meterId => !providedMeterIds.includes(meterId));
                    // console.log('missingMeters****:', missingMeters)
                    // console.log('providedMeterIds****:', providedMeterIds)
                    // console.log('requiredMeterIds****:', requiredMeterIds)
                    if (missingMeters.length > 0) {
                        const missingMeterNames = expectedMeters
                            .filter(meter => meter && meter._id && missingMeters.includes(meter._id.toString()))
                            .map(meter => meter.meterNo || meter._id)
                            .join(', ');
                        message.error(`Missing readings for meter(s): ${missingMeterNames}`);
                        return;
                    }
                }

                const quantityValue = Number(values.qty);
                if (!(quantityValue > 0)) {
                    message.error("Quantity must be greater than 0");
                    return;
                }

                // If we reach here, validation passed - proceed with submission
                // Keep second-level precision (zero the milliseconds) on both date and
                // datetime so entries made in the same minute get distinct, whole-second
                // values and stay in the order they were entered, instead of colliding.
                const fuelMoment = moment(selectedFuelDate).milliseconds(0)
                const payload = {
                    date: fuelMoment.toISOString(),
                    datetime: fuelMoment.valueOf(),
                    asset: selectedAsset,
                    assetData: selectedAssetData,
                    typeOfFuel: selectedFuelType,
                    mileage: mileageData,
                    isBowser,
                    quantity: quantityValue,
                    rate: values.rate || 0,
                    receiptNumber: receiptSelected,
                    bowserAsset: bowserAssetSelected,
                    photos: documentImage,
                    operator: values.operator,
                    isFilledToFull: !!values.isFilledToFull,
                };

                if (!isBowser) {
                    delete payload.bowserAsset;
                }

                if (isBowser && this.isSameAssetSelection(selectedAsset, bowserAssetSelected)) {
                    message.error("Issue to asset and issue from bowser cannot be the same asset.");
                    return;
                }

                // Check bowser balance validation
                if (isBowser && bowserAssetSelected && values.qty) {
                    const currentQuantity = values.qty || 0;
                    const bowserBalance = this.state.bowserBalanceQuantity || null;

                    if (currentQuantity > bowserBalance) {
                        Modal.confirm({
                            title: 'Insufficient Bowser Balance',
                            content: `The selected quantity (${currentQuantity}) is greater than the available bowser balance (${bowserBalance || 0}). You cannot proceed with this transaction.`,
                            okText: 'Ok',
                            cancelText: 'Cancel',
                            onOk: () => {
                                // this.checkWithThreshold(payload, _id);
                            },
                            onCancel: () => {
                                console.log('Submission cancelled due to insufficient bowser balance');
                            }
                        });
                        return;
                    }
                }

                // console.log('payload - ', payload)
                // console.log(this.props.assetModel);

                this.checkWithThreshold(payload, _id)

                // if (_id && typeof _id === "string" && _id.toString() !== "") {
                //     this.props.onSubmit(payload, _id);
                // } else {
                //     this.props.onSubmit(payload);
                // }
            }
        });
    };

    checkWithThreshold = (data, _id) => {
        const assetModel = this.props.assetModel;
        const { lowRange } = this.props.assetFuels || {};

        // console.log('lowRange - ', lowRange)

        const mileageList = (data && data.mileage) || [];
        const hasAtLeastOneMeter = mileageList.length > 0;
        const hasAnyFaultyMeter = !!mileageList.find((mileageItem) => mileageItem && mileageItem.isFaultyMeter);
        const isFullTankForValidation = !!(data && data.isFilledToFull && hasAtLeastOneMeter && !hasAnyFaultyMeter);
        if (data && data.mileage && assetModel && assetModel.fuelMileageThreshold && Number(data.quantity) > 0 && isFullTankForValidation) {

            axios.post('/fuel/validate-fuel-consumption-rate', { ...data, fid: _id || '' }).then(res => {
                // console.log('res - ', res)

                const { mileageWarnings: thresholdMessages } = res && res.data || {}

                // console.log('thresholdMessages - ', thresholdMessages);
                if (thresholdMessages && thresholdMessages.length > 0) {

                    Modal.confirm({
                        title: 'Alert: Mileage Threshold Exceeded',
                        // content: thresholdMessages.join('\n'),
                        content: <div>Calculated Mileage exceed threshold! Please check entry.</div>,
                        description: thresholdMessages.join('\n'),
                        okText: 'Proceed',
                        cancelText: 'Edit',
                        onOk: () => {
                            if (_id && typeof _id === 'string' && _id.toString() !== '') {
                                this.props.onSubmit(data, _id)
                            } else {
                                this.props.onSubmit(data)
                            }
                        },
                        onCancel: () => {
                            console.log('Saving cancelled due to mileage threshold warning')
                        }
                    });
                } else {
                    if (_id && typeof _id === 'string' && _id.toString() !== '') {
                        this.props.onSubmit(data, _id)
                    } else {
                        this.props.onSubmit(data)
                    }
                }
            })
        } else {
            if (_id && typeof _id === 'string' && _id.toString() !== '') {
                this.props.onSubmit(data, _id)
            } else {
                this.props.onSubmit(data)
            }
        }
    }

    calculateMileage = (startMeter, endMeter, startFuel, endFuel) => {
        // console.log('startMeter - ', startMeter);
        // console.log('endMeter - ', endMeter);
        // console.log('startFuel - ', startFuel);
        // console.log('endFuel - ', endFuel);
        const distanceTraveled = endMeter - startMeter
        const fuelConsumed = endFuel

        if (fuelConsumed <= 0) {
            console.error('Invalid fuel consumption. End fuel quantity should be less than start fuel quantity.')
            return 0;
        }
        const mileage = distanceTraveled / fuelConsumed
        return mileage
    }

    getImageData = (data) => {
        // console.log(data);
        this.props.form.setFieldsValue({ photos: data });
        this.setState({ documentImage: data });
    };

    removeExistingPhoto = (url) => {
        if (!url) return;
        const updated = (this.state.documentImage || []).filter((file) => {
            const fileUrl = file && (file.url || file.uid);
            return fileUrl !== url;
        });
        this.props.form.setFieldsValue({ photos: updated });
        this.setState((prev) => ({
            documentImage: updated,
            removedPhotoUrls: [...(prev.removedPhotoUrls || []), url],
        }));
    };

    getIsOptional = (pageSettings, name) => {
        const setting =
            pageSettings &&
            pageSettings.length &&
            pageSettings.find((p) => p.name === name);
        return setting ? setting.isOptional : undefined;
    };

    getIsHidden = (pageSettings, name) => {
        const setting =
            pageSettings &&
            pageSettings.length &&
            pageSettings.find((p) => p.name === name);
        return setting ? setting.isHidden : false;
    };

    getDefaultValue = (pageSettings, name) => {
        const setting =
            pageSettings &&
            pageSettings.length &&
            pageSettings.find((p) => p.name === name);
        return setting && setting.defaultValue;
    };

    render() {
        const { getFieldDecorator, setFieldsValue, getFieldValue } = this.props.form;
        const {
            data,
            loading,
            filters,
            title,
            resource,
            form,
            assetData,
            pageSettingData,
            assetFuels,
            authUser,
            searchGlobalAssetData,
            // assetSearchData,
            assetSearchLoading,
        } = this.props;
        // console.log(filters)
        // console.log(data)
        // const value = data && data[dataKeyObj ? dataKeyObj : item] ? (dataKeyObj ? data[dataKeyObj][dataKey] : data[dataKey]) : null;
        const {
            date,
            asset,
            typeOfFuel,
            mileage,
            quantity,
            rate,
            isBowser,
            receiptNumber,
            bowserAsset,
            operator
        } = data || {};
        // console.log('B - ', this.state.isBowser);
        // console.log('Asset =>', asset)
        // console.log('Asset Data =>', assetData)
        // console.log('Selected Asset =>', this.state.selectedAsset)
        let { mileageData } = this.state;
        if (mileage && mileage.length > 0) mileageData = mileage;
        // console.log(asset)
        let isCurrentDateOnly = false;
        if (authUser && authUser.roles && authUser.roles[0]) {
            isCurrentDateOnly = !!authUser.roles[0].refuelDateCurrentOnly;
        }
        const pageSettings = (pageSettingData && pageSettingData.settings) || [];
        const qtyValue = getFieldValue('qty');
        const isQtyInvalid = qtyValue === undefined || qtyValue === null || Number(qtyValue) <= 0;
        const availableBowsers = this.getAvailableBowsers();

        // console.log(authUser)
        // console.log(this.state.selectedAsset, asset)

        const isABowser = this.state.isBowser; // || (data && data.isBowser);
        const removedPhotoUrls = this.state.removedPhotoUrls || [];
        const currentPhotoUrls = new Set(
            (this.state.documentImage || [])
                .map((file) => file && (file.url || file.uid))
                .filter(Boolean)
        );
        const hasCurrentPhotoUrls = currentPhotoUrls.size > 0;
        const existingPhotos = (data && data.photos ? data.photos : []).filter((photo) => {
            if (!photo || !photo.url) return false;
            if (removedPhotoUrls.includes(photo.url)) return false;
            return hasCurrentPhotoUrls ? currentPhotoUrls.has(photo.url) : true;
        });
        // console.log('isABowser - ', isABowser);

        const style = {
            marginTop: "10px",
            border: "1px dashed #000",
            padding: "20px",
            borderRadius: "9px",
            display: "flex",
            justifyContent: "space-between",
        };

        const bowserItem = !isABowser ? (
            !this.getIsHidden(pageSettings, "receiptNumber") && (
                <Form.Item
                    key={`receiptNo`}
                    label="Receipt No"
                    style={{ width: "100%" }}
                >
                    {getFieldDecorator("receiptNo", {
                        rules: [
                            {
                                required:
                                    this.getIsOptional(pageSettings, "receiptNumber") || true,
                                message: "Receipt No",
                            },
                        ],
                        initialValue: receiptNumber,
                    })(
                        <Input
                            placeholder={`Receipt No`}
                            onChange={(value) => this.handleChange("receiptNo", value)}
                            style={{ width: "100%" }}
                        />,
                    )}
                </Form.Item>
            )
        ) : (
            <Form.Item
                key={"bowserAsset"}
                label={"Enter bowserAsset"}
                style={{ width: "100%" }}
            >
                {getFieldDecorator(`bowserAsset`, {
                    rules: [{ required: this.state.isBowser, message: `bowserAsset is required!` }],
                    initialValue: bowserAsset && bowserAsset.assetCode,
                })(
                    <AutoComplete
                        onSearch={this.bowserSearch}
                        onSelect={(value) => this.handleChange("bowserAsset", value)}
                        onClear={() => this.setState({
                            bowserAssetSelected: "",
                            bowserBalanceQuantity: null,
                            bowserBalanceCheck: false
                        })}
                        placeholder={"bowserAsset Code"}
                        // disabled={title === "EDIT"}
                        allowClear
                    >
                        {availableBowsers.map((item) => (
                            <Select.Option
                                // disabled={!item.stock || item.stock <= 0}
                                key={item._id}
                                value={item._id}
                            >
                                {item.assetCode}/{item.altName}/{item.ownerCode}
                            </Select.Option>
                        ))}
                    </AutoComplete>,
                )}
                {this.state.bowserAssetSelected && (
                    <div style={{ marginTop: '8px' }}>
                        {this.state.bowserBalanceCheck ? (
                            <div style={{ color: '#1890ff' }}>
                                <Icon type="loading" /> Fetching balance...
                            </div>
                        ) : (
                            <div style={{
                                padding: '8px 12px',
                                backgroundColor: this.state.qtySelected > (this.state.bowserBalanceQuantity || 0) ? '#fff2f0' : '#f6f8fa',
                                borderRadius: '4px',
                                border: `1px solid ${this.state.qtySelected > (this.state.bowserBalanceQuantity || 0) ? '#ffccc7' : '#e1e4e8'}`
                            }}>
                                <strong>Available Balance:</strong> {this.state.bowserBalanceQuantity === null ? 'No balance found' : Number(this.state.bowserBalanceQuantity || 0).toFixed(2)}
                                {this.state.bowserBalanceQuantity !== null && this.state.qtySelected > (this.state.bowserBalanceQuantity || 0) && (
                                    <div style={{ color: '#cf1322', fontSize: '12px', marginTop: '4px' }}>
                                        ⚠️ Insufficient balance for selected quantity
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                )}
            </Form.Item>
        );

        const formItems =
            mileageData &&
            mileageData.map((item, index) => {
                return (
                    <div key={index} style={style}>
                        <div>
                            <div>Meter Unit: {item.name}</div>
                            <div>Meter Reading: {item.reading}</div>
                        </div>
                        <div>
                            <Button
                                type="danger"
                                disabled={false}
                                onClick={() => this.removeMileage(`${index}`)}
                            >
                                Remove
                            </Button>
                        </div>
                    </div>
                );
            });

        // console.log(filters['typeOfFuel'])
        // console.log(this.state.selectedFuelType)
        // console.log(typeOfFuel)

        return (
            <div>
                <Spin spinning={loading}>
                    <Card
                        className={`gx-card-metrics`}
                        title={`Refuel `}
                        extra={
                            <a
                                href="#"
                                title={"Page Setting"}
                                onClick={() => this.togglePageSettingVisible()}
                            >
                                <Icon
                                    type="setting"
                                    theme="twoTone"
                                    style={{ fontSize: "25px" }}
                                />
                            </a>
                        }
                    >
                        <AccessControl
                            resource={resource}
                            permissionNeeded={"page-setting"}
                            roles={this.props.authUser ? this.props.authUser.roles : []}
                            render={() => (
                                <PageSettingPopUp
                                    toggleVisible={this.togglePageSettingVisible}
                                    visible={this.state.pageSettingVisible}
                                    page={resource}
                                    loading={loading}
                                    fetchResourceByPage={this.props.fetchResourceByPage}
                                    pageSettingData={this.props.pageSettingData}
                                    fetchPageWiseFields={this.props.fetchMasterFilter}
                                    pageWiseFields={this.props.pageWiseFields}
                                    fetchPageSettingFilter={this.props.fetchPageSettingFilter}
                                    pageSettingFilters={this.props.pageSettingFilters}
                                    updatePageSetting={this.props.pageSettingUpdate}
                                />
                            )}
                        />

                        <Form
                            onSubmit={this.handleSubmit}
                            className="ant-advanced-search-form"
                            layout="vertical"
                            labelAlign="left"
                        >
                            {title !== "CREATE" && (
                                <Form.Item
                                    key={"voucherNo"}
                                    label={"Fuel Voucher"}
                                    style={{ width: "100%" }}
                                >
                                    {getFieldDecorator(`voucherNo`, {
                                        rules: [
                                            { required: true, message: `Voucher No is required!` },
                                        ],
                                        initialValue: data && data.voucherNo,
                                    })(<Input disabled />)}
                                </Form.Item>
                            )}

                            {/* <Form.Item
                                key={"fuelDate"}
                                label={"Select Fueling Date"}
                                style={{ width: "100%" }}
                            >
                                {getFieldDecorator(`fuelDate`, {
                                    rules: [
                                        { required: true, message: `Fuel Date is required!` },
                                    ],
                                    initialValue: (date && moment(date)) || moment(),
                                })(
                                    <Datetime
                                        inputProps={{
                                            disabled: !!date,
                                            style: {
                                                width: "100%", height: '36px',
                                                lineHeight: 1.3,
                                                background: 'transparent',
                                                borderWidth: '1px',
                                                borderRadius: '5px',
                                                paddingLeft: '5px',
                                                borderColor: '#d9d9d9',
                                            }
                                        }}
                                        timeFormat="HH:mm A"
                                        dateFormat="DD/MM/YYYY"
                                        onChange={(value) => { this.handleChange("fuelDate", value) }}
                                        isValidDate={(current) =>
                                            isCurrentDateOnly
                                                ? moment(current).isSame(moment(), "day")
                                                : moment(current).isSameOrBefore(moment().endOf("day"))
                                        }
                                    />
                                )}
                            </Form.Item> */}

                            <Form.Item
                                key={"fuelDate"}
                                label={"Select Fueling Date"}
                                style={{ width: "100%" }}
                            >
                                {getFieldDecorator(`fuelDate`, {
                                    rules: [
                                        { required: true, message: `Fuel Date is required!` },
                                    ],
                                    initialValue: (date && moment(date)) || moment(),
                                })(
                                    <DatePicker
                                        showTime
                                        format={'DD/MM/YYYY HH:mm:ss A'}
                                        disabled={title === "VIEW"}
                                        // disabledDate={(current) => current && !moment(current).isSame(moment(), 'day')}
                                        disabledDate={(current) =>
                                            isCurrentDateOnly
                                                ? current && !moment(current).isSame(moment(), "day")
                                                : current && current > moment().endOf("day")
                                        }
                                        onChange={(value) => { this.handleChange("fuelDate", value) }}
                                        style={{ width: "100%" }}
                                    />,
                                )}
                            </Form.Item>

                            <Form.Item
                                key={"asset"}
                                label={"Enter Asset"}
                                style={{ width: "100%" }}
                            >
                                {getFieldDecorator(`asset`, {
                                    rules: [{ required: true, message: `Asset is required!` }],
                                    initialValue: this.state.selectedAsset ? this.state.selectedAsset : (asset && asset._id),
                                })(
                                    // (<AutoComplete onSearch={this.assetSearch}
                                    //                onSelect={value => this.handleChange('asset', value)}
                                    //                placeholder={'Asset Code'}
                                    //                disabled={title === 'EDIT'}>
                                    //   {
                                    //     assetData && assetData.length && assetData.map(item => item.assetModel && item.assetModel.fuelType ? (
                                    //       <Select.Option key={item._id}
                                    //                      value={item._id}>
                                    //         {`${item.assetCode} - ${item.altName ? item.altName : item.description ? item.description : '-'} (${item.ownerCode || '-'})`}
                                    //       </Select.Option>) : null)
                                    //   }
                                    // </AutoComplete>)
                                    <AssetSearch
                                        styleName="gx-lt-icon-search-bar-lg"
                                        placeholder="Search Assets..."
                                        onChange={this.assetSearch.bind(this)}
                                        onSelect={(value) => this.handleChange("asset", value)}
                                        disabled={title !== "CREATE"}
                                        assetData={
                                            assetData && assetData.filter((ast) => ast.assetModel) || []
                                        } // only assets with assetModel
                                        authUser={this.props.authUser}
                                        loading={assetSearchLoading}
                                        defaultAsset={asset ? asset : this.state.selectedAsset ? { _id: this.state.selectedAsset } : null}
                                    />,
                                )}
                            </Form.Item>

                            <Form.Item key={"fuelType"} label={`Fuel Type`}>
                                {getFieldDecorator(`fuelType`, {
                                    rules: [
                                        {
                                            required: true,
                                            message: `Fuel Type is required!`,
                                        },
                                    ],
                                    initialValue:
                                        this.state.selectedFuelType ||
                                        (typeOfFuel && typeOfFuel._id),
                                })(
                                    <Select
                                        showSearch
                                        placeholder={`Select Fuel Type`}
                                        disabled
                                        // disabled={this.state.selectedFuelType ? true : false}
                                        onChange={(value) => this.handleChange("fuelType", value)}
                                    >
                                        <Select.Option
                                            key={""}
                                            value={""}
                                            disabled
                                        >{`Select Fuel Type`}</Select.Option>
                                        {(
                                            (filters["typeOfFuel"] &&
                                                filters["typeOfFuel"].data.data) ||
                                            []
                                        ).map((item) => (
                                            <Select.Option key={item._id} value={item._id}>
                                                {item.name}
                                            </Select.Option>
                                        ))}
                                    </Select>,
                                )}
                            </Form.Item>

                            {/*{title === 'EDIT' && formItems}*/}

                            <Mileage
                                key={`mileage`}
                                _id={this.state._id}
                                visible={this.state.visible || !!(typeOfFuel && typeOfFuel._id)}
                                onCancel={this.handleCancel}
                                // onCreate={this.handelMileageCreate}
                                resourceName={resource}
                                filters={filters}
                                form={form}
                                // mileageData={mileageData}
                                meterReadings={data && data.mileage}
                                meterUnits={this.props.filterData && this.props.filterData.meterUnits || {}}
                                selectedAsset={this.state.selectedAsset}
                                selectedDate={this.state.selectedFuelDate}
                                isDateBased={true}
                                selectedAssetModel={this.props.assetModel}
                                assets={assetData}
                                assetFuels={assetFuels}
                                handleChange={this.handleChange}
                                setCurrentAssetMeters={this.setCurrentAssetMeters}
                            />

                            <Form.Item label="Quantity">
                                {getFieldDecorator("qty", {
                                    rules: [
                                        { required: true, message: "Quantity is required!" },
                                        {
                                            validator: (_, value, callback) => {
                                                if (value === undefined || value === null || value === '') {
                                                    callback('Quantity is required!');
                                                    return;
                                                }
                                                if (Number(value) <= 0) {
                                                    callback('Quantity must be greater than 0');
                                                    return;
                                                }
                                                callback();
                                            }
                                        }
                                    ],
                                    initialValue: quantity || 0,
                                })(
                                    <InputNumber
                                        onChange={(value) => this.handleChange("qty", value)}
                                        min={0}
                                        style={{ width: 200 }}
                                    />,
                                )}
                            </Form.Item>

                            {!this.state.isBowser && !this.getIsHidden(pageSettings, "rate") && (
                                <Form.Item label="Rate">
                                    {getFieldDecorator("rate", {
                                        rules: [
                                            {
                                                required:
                                                    this.getIsOptional(pageSettings, "rate") === undefined
                                                        ? filters &&
                                                        filters["rate"] &&
                                                        filters["rate"].options.required
                                                        : !this.getIsOptional(pageSettings, "rate"),
                                                message: "Rate",
                                            },
                                        ],
                                        initialValue: rate || 0,
                                    })(
                                        <InputNumber
                                            onChange={(value) => this.handleChange("rate", value)}
                                            style={{ width: 200 }}
                                        />,
                                    )}
                                </Form.Item>
                            )}

                            {!(this.getIsHidden(pageSettings, "isFilledToFull") && this.getIsHidden(pageSettings, "isFullTank")) && (
                                <Form.Item>
                                    {getFieldDecorator('isFilledToFull', {
                                        rules: [
                                            {
                                                required: false,
                                            },],
                                        valuePropName: 'checked',
                                        initialValue: data
                                            ? !!(data['isFilledToFull'] !== undefined ? data['isFilledToFull'] : data['isFullTank'])
                                            : ((this.getDefaultValue(pageSettings, "isFilledToFull") || this.getDefaultValue(pageSettings, "isFullTank")) === 'true' ? true : false) || false,
                                    })(<Checkbox>Is Full Tank ?</Checkbox>)}
                                </Form.Item>
                            )}

                            {!this.getIsHidden(pageSettings, "isBowser") && (
                                <Form.Item>
                                    {getFieldDecorator('isBowser', {
                                        rules: [
                                            {
                                                required: false, // this.getIsOptional(pageSettings, "isBowser"),
                                            },],
                                        valuePropName: 'checked',
                                        initialValue: data ? data['isBowser'] : this.getDefaultValue(pageSettings, "isBowser") === 'true' ? true : false || false,
                                    })(<Checkbox
                                        // disabled={title === "EDIT"}
                                        onChange={(value) => this.handleChange("isBowser", value)}
                                    >
                                        Is Filled from Bowser?
                                    </Checkbox>)}
                                    {/*<Checkbox*/}
                                    {/*  checked={isABowser || this.getDefaultValue(pageSettings, "isBowser") || false}*/}
                                    {/*  onChange={(value) => this.handleChange("isBowser", value)}*/}
                                    {/*  style={{width: 200}}*/}
                                    {/*>*/}
                                    {/*  Is Filled from Bowser?*/}
                                    {/*</Checkbox>*/}
                                </Form.Item>
                            )}

                            {bowserItem}


                            <Form.Item key={'operator'} label={'Operator'}>
                                {getFieldDecorator('operator', {
                                    rules: [{
                                        required: this.getIsOptional(pageSettings, "operator") || false,
                                        message: `Operator is required!`
                                    }],
                                    initialValue: operator && operator._id || (authUser && authUser.manpower && authUser.manpower._id),
                                })(<Select
                                    showSearch
                                    style={{ width: '80%' }}
                                    disabled={!!this.getIsHidden(pageSettings, "operator")}
                                    placeholder="Please select"
                                    filterOption={(input, option) =>
                                        (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                                    }
                                >
                                    {filters['operator'] && filters['operator']['data'] && filters['operator']['data']['data'].map(item =>
                                        <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
                                </Select>)}
                            </Form.Item>

                            <div>
                                <Row type="flex" gutter={[8, 8]}>
                                    {title !== 'VIEW' && !this.getIsHidden(pageSettings, "photos") && (
                                        <Col span={12}>
                                            <Form.Item key={"photos"} label={"Photos"}>
                                                {getFieldDecorator(
                                                    "photos",
                                                    {},
                                                )(
                                                    <ImageList
                                                        match={this.props.match}
                                                        history={this.props.history}
                                                        documentData={this.state.documentImage}
                                                        key={"photos"}
                                                        item={filters["photos"]}
                                                        form={form}
                                                        data={data && data.photos}
                                                        getDocumentData={this.getImageData.bind(this)}
                                                    />,
                                                )}
                                            </Form.Item>
                                        </Col>
                                    )}
                                </Row>
                            </div>

                            {/* Existing photos preview (view & edit) — click to open lightbox */}
                            {existingPhotos && existingPhotos.length > 0 && (
                                <div style={{ marginBottom: 16 }}>
                                    <div style={{ marginBottom: 6, fontWeight: 500 }}>Existing Photos</div>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                                        {existingPhotos.map((item, index) => (
                                            <img
                                                key={item.url}
                                                src={item.url}
                                                alt={item.name}
                                                title={item.name}
                                                onClick={() => this.setState({ photoPreview: { visible: true, index } })}
                                                style={{
                                                    width: 64,
                                                    height: 64,
                                                    objectFit: 'cover',
                                                    borderRadius: 4,
                                                    border: '1px solid #d9d9d9',
                                                    cursor: 'pointer',
                                                }}
                                            />
                                        ))}
                                    </div>
                                    <ImagePreviewModal
                                        visible={this.state.photoPreview.visible}
                                        photos={existingPhotos}
                                        initialIndex={this.state.photoPreview.index}
                                        onClose={() => this.setState((prev) => ({ photoPreview: { ...prev.photoPreview, visible: false } }))}
                                    />
                                </div>
                            )}
                            {title !== 'VIEW' &&
                                <Button
                                    data-role="fuel-save-btn"
                                    disabled={title === 'VIEW' || this.state.bowserBalanceCheck || isQtyInvalid}
                                    type="primary"
                                    htmlType="submit"
                                    loading={loading || this.state.colLoading || this.state.bowserBalanceCheck}
                                >
                                    Save
                                </Button>
                            }
                        </Form>
                    </Card>
                </Spin>
            </div>
        );
    }
}

const mapStateToProps = ({
    auth,
    fuel,
    commonData,
    asset,
    pageSetting,
    assetModel,
}) => {
    return {
        authUser: auth.authUser,
        // assetData: commonData.relationshipSearch,
        filterData: fuel.filters,
        bowsers: asset.bowsers,

        pageSettingFilters:
            commonData.pageSettingFilters /*(fetchPageSettingFilter)*/,
        pageSettingData: pageSetting.pageSettings /*fetchResourceByPage*/,
        // pageSettingData: pageSetting.edit,
        pageWiseFields:
            commonData.masterFilters /*(fetchMasterFilter -> on select a page get filelds)*/,

        assetFuels: fuel.assetFuels,
        assetData: commonData.assetSearchData,
        assetSearchLoading: commonData.assetSearchLoading,
        assetModel: assetModel.edit,
    };
};

function mapDispatchToProps(dispatch) {
    return {
        fetchRelationshipSearchData,
        fetchMasterFilterData,
        fetchBowserAssets,

        fetchMasterFilter,
        fetchPageSettingFilter,
        fetchResourceByPage,
        pageSettingUpdate,

        fetchAssetFuels,
        searchGlobalAssetData,
        fetchAssetModel,
    };
}

const RefuelForm = Form.create({ name: "refuel" })(Refuel);
export default connect(mapStateToProps, mapDispatchToProps())(RefuelForm);
